import React from 'react';
import './StatCard.css';

export const StatCard = ({ title, value, color, smallValue, onAction, actionThreshold = 0, onClick }) => {
  const accentColor = color || '#b8862f';
  const valueClass = smallValue ? "stat-value stat-value-small" : "stat-value";
  const showAction = onAction && value <= actionThreshold;

  // onClick is a different affordance than onAction's "+" button: it makes
  // the whole card a link to a filtered detail view (e.g. "go see exactly
  // which animals"), not a prompt to add a first record. The two are never
  // both present on the same card today, but nothing stops it structurally.
  const clickableProps = onClick
    ? { onClick, role: 'button', tabIndex: 0, onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } }
    : {};

  return (
    <div
      className={`StatCard${onClick ? ' StatCard-clickable' : ''}`}
      style={{ borderLeftColor: accentColor }}
      {...clickableProps}
    >
      <div className="stat-title">
        <span>{title}</span>
        {showAction && (
          <button className="stat-action" onClick={(e) => { e.stopPropagation(); onAction(); }} title="Add">
            +
          </button>
        )}
      </div>
      <div className="stat-content">
        <div className={valueClass} style={{ color: accentColor }}>{value}</div>
      </div>
    </div>
  );
};

export default StatCard;
